/* const _import = require(`./config/_import_${process.env.NODE_ENV}`) */
import _import from './config'
export default {
    path: '/client',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'client',
    redirect: '/client/resource',
    children: [
        {
            path: 'daiban',
            component: _import('client/daibanClient'),
            name: 'daibanClient',
            meta: {
                auth: true,
            }
        },{
            path: 'complaint-suggestion',
            component: _import('client/complaintAndSuggestion'),
            name: 'complaintsuggestion',
            meta: {
                auth: true,
            }
        },{
            path: 'customerStatusLog',
            component: _import('client/customerStatusLog'),
            name: 'customerStatusLog',
            meta: {
                auth: true,
            }
        },{
            path: 'resource',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'resource',
            redirect: '/client/resource/channelPool',
            children: [
                {
                    path: 'channelPool',
                    component: _import('client/resource/channelPool'),
                    name: 'channelPool',
                    meta: {
                        auth: true,
                        keepAlive:true
                    }
                }, {
                    path: 'schoolPool',
                    component: _import('client/resource/schoolPool'),
                    name: 'schoolPool',
                    meta: {
                        auth: true,
                        keepAlive:true
                    }
                }, {
                    path: 'customerVisit',
                    component: _import('client/resource/customerVisit'),
                    name: 'customerVisit',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'customerRegist',
                    component: _import('client/resource/customerRegist'),
                    name: 'customerRegist',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'coverRemind',
                    component: _import('client/resource/coverRemind'),
                    name: 'coverRemind',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'followuprecords',
                    component: _import('client/resource/followupRecords'),
                    name: 'followuprecords',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'customerFollow',
                    component: _import('client/resource/customerFollow'),
                    name: 'customerFollow',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'referral',
                    component: _import('client/resource/referral'),
                    name: 'referral',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'deposit',
                    component: _import('client/resource/depositAll'),
                    name: 'depositall',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'advancemoney',
                    component: _import('client/resource/advanceMoney'),
                    name: 'advancemoney',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'callcenter',
                    component: _import('client/resource/callCenter'),
                    name: 'callcenter',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'clientSearch',
                    component: _import('client/resource/clientSearch'),
                    name: 'clientSearch',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'callcenter/tickets',
            component: _import('client/callcenter/tickets'),
            name: 'tickets',
            meta: {
                auth: true
            }
        }, {
            path: 'callcenter/minetickets',
            component: _import('client/callcenter/mineTickets'),
            name: 'minetickets',
            meta: {
                auth: true
            }
        }, {
            path: 'schedule/schedulePlan',
            component: _import('client/schedule/schedulePlan'),
            name: 'schedulePlan',
            meta: {
                auth: true
            }
        }, {
            path: 'schedule/connectedClient',
            component: _import('client/schedule/connectedClient'),
            name: 'connectedClient',
            meta: {
                auth: true
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/client.js